import Pacientes from "./PharmacysContainer";

export default Pacientes;
